import { render, staticRenderFns } from "./TestEditMini.vue?vue&type=template&id=c845880a&"
import script from "./TestEditMini.vue?vue&type=script&lang=js&"
export * from "./TestEditMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports